import { createSlice } from '@reduxjs/toolkit'
import { authorExtraReducers } from '@store/reducres/auhtor.reducers'

export const authorUrl = 'authors/'

export interface AuthorModel {
  username: string
  email: string
}

export interface AuthorState {
  authorList: AuthorModel[]
  loading: boolean
  error: string | null
}

const initialState: AuthorState = {
  authorList: [],
  loading: false,
  error: null,
}

const authorSlice = createSlice({
  name: 'author',
  initialState,
  reducers: {},
  extraReducers: authorExtraReducers,
})

export default authorSlice.reducer
